<template>
  <SettingsSection :title="$t('platform.card.sections.verification_title')" :description="verifiedAt ? '' : $t('platform.card.sections.verification')">
    <p v-if="verifiedAt" class="verified">
      <svg v-svg symbol="check" size="0 0 17 17" role="presentation" />
      {{ $t("platform.card.fields.verified", { date: verifiedDate }) }}
    </p>
    <CheckSite v-else class="row" :platformId="subaccount.id" :url="subaccount.url" :status="status" :type="type" @setStatus="status = $event" @setType="type = $event" @verified="verifiedAt = $event" />
  </SettingsSection>
</template>
<script>
import CheckSite from "@/components/CheckSite.vue";
import SettingsSection from "@/components/PlatformCard/SettingsSection.vue";

// The optional confirmation that the site of a platform belongs to the user: confirmed sites get the best advertisers
export default {
  name: "VerificationSection",
  components: { CheckSite, SettingsSection },
  props: {
    subaccount: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      verifiedAt: this.subaccount.verified_at || null,
      // The status of the check, as CheckSite reports it
      status: 0,
      type: this.subaccount.check_type || 1,
    };
  },
  computed: {
    verifiedDate() {
      return new Date(this.verifiedAt * 1000).toLocaleDateString(this.$i18n.locale);
    },
  },
};
</script>
<style lang="scss" scoped>
.verified {
  display: flex;
  align-items: center;
  column-gap: 8px;
  margin: 0;
  color: #37807d;

  svg {
    width: 17px;
    height: 17px;
    fill: #37807d;
  }
}
</style>
